import { I18n } from '@calendly/i18n'
import { AlertWarningCircleIcon, CheckCircleIcon, CloseCircleIcon } from '@calendly/ui/components/icons'
import { colorIconDestructive, colorIconSuccess, colorIconWarning } from '@calendly/ui/theme'

import {
  Tooltip,
  TooltipContainer,
  EmailsWrapper
} from './styles'

const NoneConnected = ({ name }) => (
  <>
    <TooltipContainer>
      <Tooltip>
        {I18n.t('publisher.components.calendars_status.none_connected_tooltip', { name })}
      </Tooltip>
      <CloseCircleIcon spacingRight={8} color={colorIconDestructive} size="large" />
    </TooltipContainer>
    {I18n.t('publisher.components.calendars_status.none_connected')}
  </>
)

const AllConnected = ({ calendarAccounts }) => (
  <>
    <TooltipContainer>
      <Tooltip>
        {I18n.t('publisher.components.calendars_status.all_connected_tooltip')}
        <EmailsWrapper>
          {calendarAccounts.map(({ email }) => email).join('\n')}
        </EmailsWrapper>
      </Tooltip>
      <CheckCircleIcon spacingRight={8} color={colorIconSuccess} size="large" />
    </TooltipContainer>
    {I18n.t('publisher.components.calendars_status.all_connected')}
  </>
)

const SomeConnected = ({ name, calendarAccounts }) => (
  <>
    <TooltipContainer>
      <Tooltip>
        {I18n.t('publisher.components.calendars_status.some_connected_tooltip', { name })}
        <EmailsWrapper>
          {calendarAccounts
            .filter(({ connected }) => !connected)
            .map(({ email }) => email)
            .join('\n')}
        </EmailsWrapper>
      </Tooltip>
      <AlertWarningCircleIcon spacingRight={8} color={colorIconWarning} size="large" />
    </TooltipContainer>
    {I18n.t('publisher.components.calendars_status.some_connected')}
  </>
)

export const CalendarsStatus = ({ name, calendarAccounts }) => {
  if (!calendarAccounts.length) {
    return <NoneConnected name={name} calendarAccounts={calendarAccounts} />
  }

  if (calendarAccounts.every(({ connected }) => connected)) {
    return <AllConnected name={name} calendarAccounts={calendarAccounts} />
  }

  return <SomeConnected name={name} calendarAccounts={calendarAccounts} />
}
